import { useEffect, useRef } from "react";
import { trackEvent } from "helpers/analytics/analytics";

/**
 * Fires a GA4 event once when the element enters the viewport.
 */
const useTrackWhenVisible = (eventName, params = {}, threshold = 0.5) => {
  const ref = useRef(null);
  const trackedRef = useRef(false);
  const paramsRef = useRef(params);

  paramsRef.current = params;

  useEffect(() => {
    const element = ref.current;
    if (!element || trackedRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting || trackedRef.current) return;
        trackedRef.current = true;
        trackEvent(eventName, paramsRef.current);
        observer.disconnect();
      },
      { threshold }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [eventName, threshold]);

  return ref;
};

export default useTrackWhenVisible;
